document.addEventListener("DOMContentLoaded", function () {
  // ========== MOBILE MENU TOGGLE ==========
  var burger = document.getElementById("navbar-burger");
  var menu = document.getElementById("navMenu");

  burger.addEventListener("click", function () {
    burger.classList.toggle("is-active");
    menu.classList.toggle("is-active");
  });

  // ========== SMOOTH SCROLL NAVIGATION ==========
  var navLinks = document.querySelectorAll(".nav-link");

  navLinks.forEach(function (link) {
    link.addEventListener("click", function (e) {
      e.preventDefault();
      var targetId = this.getAttribute("data-target");
      var target = document.getElementById(targetId);
      if (target) {
        target.scrollIntoView({ behavior: "smooth" });
        // Close mobile menu if open
        burger.classList.remove("is-active");
        menu.classList.remove("is-active");
      }
    });
  });

  // ========== HEADER SCROLL EFFECT ==========
  var header = document.getElementById("main-header");

  window.addEventListener("scroll", function () {
    if (window.scrollY > 20) {
      header.classList.add("is-scrolled");
    } else {
      header.classList.remove("is-scrolled");
    }
  });

  // ========== PROJECT CATEGORY FILTER ==========
  var filterButtons = document.querySelectorAll(".filter-btn");
  var projectItems = document.querySelectorAll(".project-item");

  filterButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var category = this.getAttribute("data-category");

      // Update active button
      filterButtons.forEach(function (b) {
        b.classList.remove("is-active", "is-link");
        b.classList.add("is-light");
      });
      this.classList.add("is-active", "is-link");
      this.classList.remove("is-light");

      // Filter projects
      projectItems.forEach(function (item) {
        if (category === "All" || item.getAttribute("data-category") === category) {
          item.classList.remove("is-hidden");
        } else {
          item.classList.add("is-hidden");
        }
      });
    });
  });

  // ========== CONTACT FORM ==========
  var contactForm = document.getElementById("contact-form");

  contactForm.addEventListener("submit", function (e) {
    e.preventDefault();
    alert("Thank you for your message! We'll get back to you soon.");
    contactForm.reset();
  });

  // ========== SCROLL REVEAL ==========
  var revealElements = document.querySelectorAll(".scroll-reveal");

  var revealObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-visible");
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  revealElements.forEach(function (el) {
    revealObserver.observe(el);
  });

  // ========== COUNT-UP ANIMATION ==========
  var countElements = document.querySelectorAll(".count-up");

  function animateCount(el) {
    var target = parseFloat(el.getAttribute("data-target"));
    var suffix = el.getAttribute("data-suffix") || "";
    var decimals = parseInt(el.getAttribute("data-decimals")) || 0;
    var duration = 2000;
    var startTime = null;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      var progress = Math.min((timestamp - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = eased * target;

      el.textContent = current.toFixed(decimals) + suffix;

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  }

  var countObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        animateCount(entry.target);
        countObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });

  countElements.forEach(function (el) {
    countObserver.observe(el);
  });

  // ========== FOOTER COPYRIGHT YEAR ==========
  var copyrightText = document.getElementById("copyright-text");
  var year = new Date().getFullYear();
  copyrightText.textContent = "All rights reserved " + year + "\u00AE Multiservicios Mavu LLC";
});
